import { Component, Inject, Injectable, OnInit, ViewChild } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, Observer, Subject, Subscription } from 'rxjs';
import { Environment } from '../../../../environments/enviroment.model';
import { BackendService } from '../../../core/backend.service';
import { EnvironmentProvider } from '../../../core/browser-providers';
import { TranslateService } from '../../../core/translate.service';
import { Actions, GenericListComponent, HasAction, Page } from '../../../shared-components/generic-list/generic-list.component';
import { MediaService } from '../../../shared-services/media.service';
import { SnackService } from '../../../shared-services/snack.service';
import { UpdateEventService } from '../../../shared-services/update-event.service';
import { CostoEnvio } from '../costo-envio.model';
import { Http, Response } from '@angular/http';
import { SecurityService } from '../../../security/security.service';
import { DialogService } from '../../../shared-components/modals/dialog.service';

interface Filters {
  description: string;
  page: number;
  size: number;
  search?: string;
}

@Component({
  selector: 'app-costo-envio-list',
  templateUrl: './costo-envio-list.component.html',
  styleUrls: ['./costo-envio-list.component.scss']
})

@Injectable()
export class CostoEnvioListComponent implements OnInit {

  private backendUrl: string;

  private filters: Filters = {
    description: undefined,
    page: 0,
    size: 10,
  };

  columns = [
    { name: 'codigoPostal',  label: 'Codigo Postal' },
    { name: 'costoEnvio',  label: 'Costo de Envio' },
    { name: 'nombreintervalos',  label: 'Provincia' },
    
  ];

  public showFilters = true;
  isMobile: boolean;

  @ViewChild(GenericListComponent)
  private genericListComponent: GenericListComponent;

  private getNewPage = new Subject<Filters>();

  public totalItems: number;

  public hasActions: HasAction;

  filtersActive = false;
  mostrarResumen = false;
  isLoading = false;

  filtersLoaded = false;
  subscriptions: Subscription[] = [];

  itemsList = this.backendService.newSubjectWithoutDistinct<Filters>()
  .switchMap(filters => {
    const proveedoresPromise = this.backendService.get(CostoEnvio, CostoEnvio.path, filters).toPromise();
    return (async () => {
      this.isLoading = true;
      try {
        const proveedores = await proveedoresPromise;
        return proveedores;
      } catch (error) {
        return [];
      }
      finally {
        this.isLoading = false;
        this.filtersActive = !(this.filters.search === '' || this.filters.search === undefined);
      }
    })();
  }).share() as Observer<Filters> & Observable<CostoEnvio[]>;

  constructor(
    @Inject(EnvironmentProvider) env: Environment,
    private route: ActivatedRoute,
    private backendService: BackendService,
    private paginatorsLabels: MatPaginatorIntl,
    private snackService: SnackService,
    private traslateService: TranslateService,
    public router: Router,
    protected updateEventService: UpdateEventService,
    private mediaService: MediaService,
    private http: Http,
    public securityService: SecurityService,
    private dialogService: DialogService,
  ) {
    this.backendUrl = env.endpoints.api + '/backend';
  }

  ngOnInit() {
    this.showFilters = true;
    this.filtersLoaded = true;

    this.hasActions = new HasAction();

    this.hasActions.hasAction = true;
    this.hasActions.actions = [{ 'element': Actions.edit, 'permission': 'EDITAR_PROVEEDOR'},
                              { 'element': Actions.delete, 'permission': 'ELIMINAR_PROVEEDOR'}];

    this.subscriptions.push(this.mediaService.isMobile.subscribe(isMobile => {
      this.isMobile = isMobile;
      this.showFilters = !this.isMobile;
    }));

    this.paginatorsLabels.itemsPerPageLabel = 'Filas por página:';

    this.itemsList.subscribe(t => {
      this.isLoading = false;
      this.totalItems = t['totalItems'];
    });

    this.refreshItemsList();
  }


  refreshItemsList() {
    this.itemsList.next(this.getFilters());
  }

  getDefaultFilters() {
    this.filters = {
      description : undefined,
      page: 0,
      size: 10,
    };
  }

  getFilters() {
    return this.filters;
  }

  // Seteo de filtros
  toggleFilters() {
    this.showFilters = !this.showFilters;
  }

  onPageChange(page: Page) {
    this.filters.page = page.pageIndex;
    this.filters.size = page.pageSize;
    this.refreshItemsList();
  }

  onSearch(searchText) {
    this.filters.search = 'codigoPostal:' + searchText;
    this.refreshItemsList();
  }

  clearSearch() {
      this.refreshItemsList();
  }

  getData(response: Response) {
    const data = response.json();
    if (response.ok) { return data; }
    throw data['hydra:description'] || data['message'];
  }

  displayFilters(boolean: boolean) {
    this.showFilters = boolean;
  }

  onAdd() {
    this.router.navigate(['/costos-envio/agregar']);
  }


  onEdit(c: CostoEnvio) {
    this.router.navigate(['/costos-envio/editar', c.id]);
  }


  /*async onDelete(proveedor: CostoEnvio) {

    this.dialogService.confirm('Eliminar proveedor',
    '¿Está seguro que desea eliminar las proveedores ' + proveedor.razonSocial + '?')
    .then( res => {
      if (res) {
        this.deleteProveedor(res, proveedor);
      }
    });

  }

  async deleteProveedor(res, proveedor: Proveedor) {

    if (res) {

      this.snackService.spinner(true);

      try {
        await this.backendService.delete(Proveedor.path + proveedor.id);
        this.snackService.success('Proveedores eliminados correctamente');
      } catch (ex) {
        this.snackService.error(ex.message);
      } finally {
        this.snackService.spinner(false);
        this.refreshItemsList();
      }

    }

  }*/

  onFiltersChanged(event) {
    this.refreshItemsList();
  }

  removeChip(event) {
    this.refreshItemsList();
  }

  async ConfirmPrueba() {
    this.dialogService.modificacionPreciosCostoEnvio()
    .then( res => {
      if (res) {
        //this.saveItem(res);
        this.snackService.spinner(true);
        this.refreshItemsList();
        this.snackService.spinner(false);
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/pedido/costo-envio/costo-envio-list/costo-envio-list.component.ts